import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';


export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);


  req = req.clone({
    withCredentials: true
  });

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // SEGURIDAD: Manejo de errores de autenticación
      if (error.status === 401 || error.status === 403) {
        // Token expirado/inválido (401) o posible token expirado devuelto como 403
        if (!req.url.includes('/auth/refresh') && !req.url.includes('/auth/admin/login')) {
          // Intentar refresh automático
          const errorType = error.status === 401 ? 'expired' : 'forbidden (possibly expired)';
          if (!environment.production) {
            console.warn(`[Security] Token ${errorType}, attempting automatic refresh`);
          }
          return authService.refreshToken().pipe(
            switchMap(() => {
              if (!environment.production) {
                console.warn('[Security] Token refreshed successfully, retrying request');
              }
              // Clonar request con withCredentials para enviar nueva cookie
              return next(req.clone({ withCredentials: true }));
            }),
            catchError((refreshError) => {
              // Refresh falló - sesión comprometida
              if (!environment.production) {
                console.warn('[Security] Token refresh failed, logging out user', refreshError);
              }
              authService.logout();
              // IMPORTANTE: No exponer detalles del error de refresh al cliente
              return throwError(() => new Error('Authentication failed'));
            })
          );
        } else {
          // Error en el endpoint de refresh/login - no reintentar
          if (!environment.production) {
            console.error(`[Security] Auth endpoint returned ${error.status}, session invalid`);
          }
        }
      }

      // Propagar el error original
      return throwError(() => error);
    })
  );
};
